import { ToastController } from './ToastController'

export const toastController = new ToastController()
